import React, { FC } from 'react';

import { PrivateRoute } from '#/components/routes/PrivateRoute';
import { BaseRoutes } from '#/containers/router/BaseRoutes';
import { Private } from '#/containers/router/routes/Private';
import { LazyLoader } from '#/utils/LazyLoader';

const ZendeskIndex = LazyLoader(() => import('../../pages/zendesk/index/ZendeskIndex.page'));
const ZendeskTicket = LazyLoader(() => import('../../pages/zendesk/ticket/ZendeskTicket.page'));
const ZendeskTicketAI = LazyLoader(() => import('../../pages/zendesk/ai/ZendeskTicketAI.page'));

export const ZendeskRouter: FC = props => {
  return (
    <BaseRoutes>
      <PrivateRoute path={Private.ZENDESK_INDEX.route} element={<ZendeskIndex />} {...props} />
      <PrivateRoute path={Private.ZENDESK_TICKET.route} element={<ZendeskTicket />} {...props} />
      <PrivateRoute path={Private.ZENDESK_TICKET_AI.route} element={<ZendeskTicketAI />} {...props} />
    </BaseRoutes>
  );
};
